// components/UserProfile/FamilyDetails.js
import React, { useEffect, useState } from "react";
import { renderMemberTree, buildMemberHierarchy } from "../../utils/Utilities";
import { useSelector } from "react-redux";
import { getUserFamily } from "../../service/UserApi";
import { useNavigate } from "react-router-dom";
import FamilySmartCard from '../family/FamilySmartCard';
import { Loading } from "../../components/shared";
const FamilyDetails = () => {
  const user = useSelector((state) => state.user);
  const [family, setFamily] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  // Local spinner component
  const Spinner = () => (
    <div style={{ textAlign: "center", padding: "20px", fontSize: "18px", color: "#555" }}>
      🔄 குடும்ப விவரங்கள் ஏற்றப்படுகின்றன...
      <Loading/>
    </div>
  );

  useEffect(() => {
    const fetchFamily = async () => {
      if (!user.email) return;
      if (!user.otpValidatedSession) {
        navigate(`/user/validate-session-otp?from=family`);
        return;
      }
      setLoading(true);

      try {
        const res = await getUserFamily(user.email);
        if (res?.otpValidatedSession === false) {
          navigate(`/user/validate-session-otp?from=family`);
        }
        setFamily(res?.family || null);
      } catch (error) {
        console.error("Error fetching family data:", error);
        setFamily(null);
      } finally {
        setLoading(false);
      }
    };

    fetchFamily();
  }, [user.email]);

  function normalizeFamilyData(family) {
    if (!family) return null;
    const head = family.members.find(member => member.aadhar === family.familyHeadAadhar);
    return {
      family: {
        ...family,
        familyMembers: family.members || [],
        familyHeadPhotoPath: {
          signedUrl: head?.photoPath?.signedUrl || null
        }
      }
    }
  }


  if (loading) return <Spinner />;

  if (!family) {
    return (
      <div className="detail-card">
        <div className="detail-item">
          <h4>உங்கள் குடும்பத்தைப் பதிவு செய்யவும். விண்ணப்பப் படிவம் கோவிலில் கிடைக்கும்...</h4>
          <br />
          <h4>குடும்ப விவரங்களை பார்க்க சரியான மொபைல் மற்றும் ஆதார் எண்ணுடன் உங்கள் இணைய கணக்கைப் புதுப்பிக்கவும்.</h4>
        </div>
        <button onClick={() => navigate(`/user/family/create`)}>புதிய குடும்பத்தை பதிவு செய்யவும்</button>
      </div>
    );
  }
  const familyStatus = family?.status || "";
  return (
    <>
      <h3>குடும்ப விவரங்கள்</h3>
      <br />
      {user?.roles?.includes('FamilyAdmin')
        && (
          <>
            <FamilySmartCard familyData={normalizeFamilyData(family)} printEnable={user?.roles?.includes('FamilyAdmin')} />
            <br />
          </>

        )}

      {familyStatus !== "pending" && family.id && family.id !== '' && (
        <div className="detail-item">
          <div className="detail-label"><strong>குடும்பப் எண்:</strong></div>
          <div className="detail-value">{family.id}</div>
        </div>
      )}

      {familyStatus !== "active" && (
        <div className="detail-item">
          <span className="detail-label"><strong>நிலை:</strong></span>

          <span style={{ color: ['draft', 'inactive', 'pending'].includes(family.status) ? 'red' : 'inherit' }}>
            {family.status || ""}
          </span>

        </div>
      )}
      {family.kootamName && family.kootamName !== "பிற" && (
        <div className="detail-item">
          <div className="detail-label"><strong>கூட்டம்:</strong></div>
          <div className="detail-value">{family.kootamName}</div>
        </div>
      )}

      {family.kootamName?.trim() === "பிற" && (
        <div className="detail-item">
          <div className="detail-label"><strong>பிற:</strong></div>
          <div className="detail-value">{family.customGroup || ""}</div>
        </div>
      )}

      <div className="detail-item">
        <div className="detail-label"><strong>குடும்பப் பெயர்:</strong></div>
        <div className="detail-value">{family.familyName || ""}</div>
      </div>

      {/* Address Block */}
      <br />
      <div className="detail-card">
        {family.addressData?.tempAddress?.name_tamil && (
          <div className="detail-item">
            <div className="detail-label"><strong>தற்காலிக முகவரி:</strong></div>
            <div className="detail-value">
              {[family.tempAddressLine1_tamil, family.tempAddressLine2_tamil, family.tempAddressLine3_tamil]
                .filter(Boolean).join(", ")}
              <br />
              {family.addressData.tempAddress.subAreas?.[0]?.name_tamil
                ? family.addressData.tempAddress.subAreas[0].name_tamil.split("|").reverse().join(", ")
                : "******"}
              <br />
              {[family.addressData.tempAddress.name_tamil, family.addressData.tempAddress.block_tamil,
              family.addressData.tempAddress.district_tamil, family.addressData.tempAddress.state_tamil,
              family.addressData.tempAddress.country_tamil, family.addressData.tempAddress.pincode]
                .filter(Boolean).join(", ")}
            </div>
          </div>
        )}

        <hr />

        {family.addressData?.permanentAddress?.name_tamil && (
          <div className="detail-item">
            <div className="detail-label"><strong>நிரந்தர முகவரி:</strong></div>
            <div className="detail-value">
              {[family.permanentAddressLine1_tamil, family.permanentAddressLine2_tamil, family.permanentAddressLine3_tamil]
                .filter(Boolean).join(", ")}
              <br />
              {family.addressData.permanentAddress.subAreas?.[0]?.name_tamil
                ? family.addressData.permanentAddress.subAreas[0].name_tamil.split("|").reverse().join(", ")
                : "******"}
              <br />
              {[family.addressData.permanentAddress.name_tamil, family.addressData.permanentAddress.block_tamil,
              family.addressData.permanentAddress.district_tamil, family.addressData.permanentAddress.state_tamil,
              family.addressData.permanentAddress.country_tamil, family.addressData.permanentAddress.pincode]
                .filter(Boolean).join(", ")}
            </div>
          </div>
        )}
      </div>

      {/* Member Tree */}
      <h4>உறுப்பினர்கள்</h4>
      <br />
      <div className="tree-container">
        {family.members?.length > 0
          ? renderMemberTree(buildMemberHierarchy(family))
          : <p>உறுப்பினர்கள் இல்லை</p>}
      </div>
      {(familyStatus === "pending") && (
        <div style={{ marginTop: "20px", textAlign: "center" }}>
          <button onClick={() => navigate(`/user/family/view/${family.id}`)}>
            குடும்ப விவரங்களைப் பார்க்க
          </button>
        </div>
      )}
      {familyStatus !== "pending" && family.id && family.id !== '' && (
        <div style={{ marginTop: "20px", textAlign: "center" }}>
          <button onClick={() => navigate(`/user/family/missing-info-update`)}>
            குடும்ப விவரங்கள் புதுப்பிப்பு
          </button>
        </div>
      )}
      <div style={{ marginTop: "30px", textAlign: "center", fontSize: "14px", color: "#555" }}>
        <p>
          ⚠️ முழு விவரங்கள் தெரியவில்லை என்றால், உங்கள் ஆதார் மற்றும் பெயரைக் கணக்கில் புதுப்பிக்கவும்.
          <br />
          அதன் பிறகும் விவரங்கள் தெரியவில்லையெனில், கீழ்க்கண்ட மின்னஞ்சலுக்கு தொடர்பு கொள்ளவும்
          <br />
          <strong>தயவுசெய்து உங்கள் பிரச்சனை குறித்த ஸ்கிரீன்‌ஷாட்டையும் இணைக்கவும்.</strong>
          <br />
          <a
            href="mailto:sriponnachiammantemples@gmail.com?subject=தகவல்%20விவரங்கள்%20தெரியவில்லை&body=வணக்கம்,%20எனது%20குடும்ப%20விவரங்கள்%20முழுவதும்%20தெரியவில்லை.%20தயவுசெய்து%20உதவி%20செய்யவும்."
            style={{ color: "#007bff", textDecoration: "none" }}
          >
            📧 sriponnachiammantemples@gmail.com
          </a>
        </p>
      </div>


    </>
  );
};

export default FamilyDetails;
